<template>
	<div id="system-select">
		<node-list
			v-slot="{ item, active }"
			:items="systems"
			:active-item="selectedSystem"
			:search-label="strings.room.search"
			@click="selectSystem"
		>
			<v-list-item-icon>
				<v-icon :color="itemColor(item, active)">fa-door-open</v-icon>
			</v-list-item-icon>

			<v-list-item-content>
				<v-list-item-title v-text="item.name" />
			</v-list-item-content>

			<div v-if="active">
				<v-list-item-action-text>In progress</v-list-item-action-text>
				<v-list-item-action>
					<v-icon small color="orange">fa-wrench</v-icon>
				</v-list-item-action>
			</div>
			<div v-else-if="isInstalled(item.id)">
				<v-list-item-action-text>Installed</v-list-item-action-text>
				<v-list-item-action>
					<v-icon small color="ocean">fa-check-circle</v-icon>
				</v-list-item-action>
			</div>
		</node-list>

		<dialog-confirm-dialog ref="confirmDialog" :body="strings.room.confirm" />
	</div>
</template>

<style lang="scss" scoped>
.selection-row {
	align-self: start;
}

#system .list-item.active {
	// NOTE: Due to libsass bug, can't use `var(--v-orange-base)` inside of rgba function.
	background-color: rgba(orange, 0.1);
}
</style>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import strings from "@/utils/strings";

export default {
	props: {
		// Show confirmation dialog when selecting a system that has already
		// been installed.
		confirmInstalled: { type: Boolean, default: true },

		// Only show installed systems.
		installedOnly: { type: Boolean, default: false },
	},

	data: () => ({
		strings,
	}),

	computed: {
		...mapGetters({
			_systems: "rooms/items",
			isInstalled: "rooms/isInstalled",

			selectedSystem: "session/system",
		}),

		systems() {
			return this._systems;
			// if (!this.installedOnly) return this._systems;
			// return _.filter(this._systems, { installed: true });
		},
	},

	methods: {
		async selectSystem(item) {
			let confirmed = !this.confirmInstalled;

			if (!confirmed) {
				if (
					(this.selectedSystem && this.selectedSystem.id === item.id) ||
					!this.isInstalled(item.id)
				) {
					confirmed = true;
				} else {
					confirmed = await this.$refs.confirmDialog.pop();
				}
			}

			if (confirmed) {
				const next = this.$route.meta.next
					? {
							...this.$route.meta.next,
							params: { systemId: item.id },
					  }
					: { path: `${item.id}`, append: true };
				return this.$router.push(next);
			}
		},

		itemColor(item, active, klass = false) {
			if (active) {
				if (klass) return "orange--text text--darken-1";
				else return "orange";
			} else if (this.isInstalled(item.id)) {
				if (klass) return "ocean--text text--darken-1";
				return "ocean";
			}
		},
	},
};
</script>
